var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LinkedControlItem',{attrs:{"label":_vm.label,"min":_vm.min},on:{"input":val => _vm.$emit('change', val)},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }